/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AIConfigTargetingEnvironmentFallthroughRollout,
  AIConfigTargetingEnvironmentFallthroughRollout$inboundSchema,
  AIConfigTargetingEnvironmentFallthroughRollout$Outbound,
  AIConfigTargetingEnvironmentFallthroughRollout$outboundSchema,
} from "./aiconfigtargetingenvironmentfallthroughrollout.js";

export type AIConfigTargetingEnvironmentFallthrough = {
  variation?: number | undefined;
  rollout?: AIConfigTargetingEnvironmentFallthroughRollout | undefined;
};

/** @internal */
export const AIConfigTargetingEnvironmentFallthrough$inboundSchema: z.ZodType<
  AIConfigTargetingEnvironmentFallthrough,
  z.ZodTypeDef,
  unknown
> = z.object({
  variation: z.number().int().optional(),
  rollout: AIConfigTargetingEnvironmentFallthroughRollout$inboundSchema
    .optional(),
});
/** @internal */
export type AIConfigTargetingEnvironmentFallthrough$Outbound = {
  variation?: number | undefined;
  rollout?: AIConfigTargetingEnvironmentFallthroughRollout$Outbound | undefined;
};

/** @internal */
export const AIConfigTargetingEnvironmentFallthrough$outboundSchema: z.ZodType<
  AIConfigTargetingEnvironmentFallthrough$Outbound,
  z.ZodTypeDef,
  AIConfigTargetingEnvironmentFallthrough
> = z.object({
  variation: z.number().int().optional(),
  rollout: AIConfigTargetingEnvironmentFallthroughRollout$outboundSchema
    .optional(),
});

export function aiConfigTargetingEnvironmentFallthroughToJSON(
  aiConfigTargetingEnvironmentFallthrough:
    AIConfigTargetingEnvironmentFallthrough,
): string {
  return JSON.stringify(
    AIConfigTargetingEnvironmentFallthrough$outboundSchema.parse(
      aiConfigTargetingEnvironmentFallthrough,
    ),
  );
}
export function aiConfigTargetingEnvironmentFallthroughFromJSON(
  jsonString: string,
): SafeParseResult<
  AIConfigTargetingEnvironmentFallthrough,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      AIConfigTargetingEnvironmentFallthrough$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'AIConfigTargetingEnvironmentFallthrough' from JSON`,
  );
}
